module.exports = __webpack_public_path__ + "img/yaqui.7c8b493b.jpg";